import { AlertTriangle, CheckCircle2, ShieldAlert } from 'lucide-react';
import type { AdminCompanyAlert } from 'app/javascript/types/admin';
import { Alert, AlertTitle } from 'app/javascript/components/ui/alert';
import { Card } from 'app/javascript/components/ui/card';

// The verdict, above everything else: what is wrong with this academy right
// now. Rules live in Admin::CompanyHealthService — the page only renders them.
//
// Critical and warning are not peers, so they don't look alike: a critical
// alert gets its own block, warnings collapse into one dense list. Five
// full-width banners would push the actual data below the fold and flatten
// the difference between "broken" and "worth a look".
export default function HealthAlerts({ alerts }: { alerts: AdminCompanyAlert[] }) {
  const critical = alerts.filter((alert) => alert.severity === 'critical');
  const warnings = alerts.filter((alert) => alert.severity !== 'critical');

  if (alerts.length === 0) {
    return (
      <Alert className="border-emerald-500/30 text-emerald-400">
        <CheckCircle2 />
        <AlertTitle>Nenhum alerta — esta academia está operando normalmente.</AlertTitle>
      </Alert>
    );
  }

  return (
    <div className="space-y-3">
      {critical.map((alert) => (
        <Alert key={alert.key} variant="destructive" className="border-destructive/40 bg-destructive/5">
          <ShieldAlert />
          <AlertTitle className="line-clamp-none font-semibold">{alert.message}</AlertTitle>
        </Alert>
      ))}

      {warnings.length > 0 && (
        <Card className="divide-y divide-border">
          {warnings.map((alert) => (
            <p key={alert.key} className="flex items-start gap-2.5 px-4 py-2.5 text-sm">
              <AlertTriangle className="mt-0.5 size-4 shrink-0 text-amber-400" />
              {alert.message}
            </p>
          ))}
        </Card>
      )}
    </div>
  );
}
